<ion-content>

    <div class="SC-empty-state-div">
        <ion-icon name="person-outline" class="SC-empty-state-icon"></ion-icon>
        <p class="SC-empty-state-text"><b>Your are signed in as a Client or Guest account.</b></p>
        <p class="SC-empty-state-text">Please log into your Business profile to access this page.</p>
        <p class="log-out" (click)="logOut()">
            Sign out
        </p>
    </div>

</ion-content>